export const licenseCountryOptions = [
  { value: '', text: 'Sin país asignado' },
  { value: 'Argentina', text: 'Argentina' },
  { value: 'Australia', text: 'Australia' },
  { value: 'Belgium', text: 'Belgium' },
  { value: 'Bolivia', text: 'Bolivia' },
  { value: 'Brasil', text: 'Brasil' },
  { value: 'Canada', text: 'Canada' },
  { value: 'Chile', text: 'Chile' },
  { value: 'Colombia', text: 'Colombia' },
  { value: 'Costa Rica', text: 'Costa Rica' },
  { value: 'Ecuador', text: 'Ecuador' },
  { value: 'El Salvador', text: 'El Salvador' },
  { value: 'España', text: 'España' },
  { value: 'Estados Unidos', text: 'Estados Unidos' },
  { value: 'France', text: 'France' },
  { value: 'Germany', text: 'Germany' },
  { value: 'Guatemala', text: 'Guatemala' },
  { value: 'Honduras', text: 'Honduras' },
  { value: 'India', text: 'India' },
  { value: 'Italy', text: 'Italy' },
  { value: 'Jamaica', text: 'Jamaica' },
  { value: 'México', text: 'México' },
  { value: 'New Zealand', text: 'New Zealand' },
  { value: 'Nicaragua', text: 'Nicaragua' },
  { value: 'Panamá', text: 'Panamá' },
  { value: 'Paraguay', text: 'Paraguay' },
  { value: 'Perú', text: 'Perú' },
  { value: 'Portugal', text: 'Portugal' },
  { value: 'Puerto Rico', text: 'Puerto Rico' },
  { value: 'República Dominicana', text: 'República Dominicana' },
  { value: 'Switzerland', text: 'Switzerland' },
  { value: 'Trinidad and Tobago', text: 'Trinidad and Tobago' },
  { value: 'Turkey', text: 'Turkey' },
  { value: 'United Arab Emirates', text: 'United Arab Emirates' },
  { value: 'United Kingdom', text: 'United Kingdom' },
  { value: 'Uruguay', text: 'Uruguay' },
  { value: 'Venezuela', text: 'Venezuela' }
]
